import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['index', 'clientPricingUnit', 'workDays', 'amount']);
  const modifyProjectClient = `modifyProjectClient(input: ${dataModify})`;
  return gql`
  mutation {
    ${modifyProjectClient} {
      id
    }
  }
`;
};
